import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step1 from './Step1-redux';

export default compose(
  withRouter,
  withNextStep
)(Step1);
